module.exports = __webpack_public_path__ + "static/img/Y1D50.f1d5e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y1D50.png
// module id = McXj
// module chunks = 2